<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          Training Information
        </h3>
      </div>
      <template v-if="training_info.length > 0">
        <div class="d-flex flex-wrap justify-content-between">
          <div v-for="(item, index) in training_info" :key="index" class="col-md-6 my-2">

             <div class="card-item">
               <div class="form-group row align-items-center">
                 <div class="col-6">
                   <label class="col-sm-12 mb-sm-1">{{ item.title }}</label>
                 <label class="col-sm-12 mb-sm-1">{{ item.awarding_body }}</label>
                 <label class="col-sm-12 mb-sm-1">Award Date {{ dateFormatter(item.award_date) }}</label>
                 <label class="col-sm-12 mb-sm-1">Expiry Date {{ dateFormatter(item.expiry_date) }}</label>

                 </div>

                 <div class="col-6" v-if="isAdmin">
                   <div v-if="item.screening_endorsement">
                     Endorsements
                     <p><strong>Requested At:</strong> {{ item.screening_endorsement.requested_at }}</p>
                     <p v-if="item.screening_endorsement.endorsed_at">
                       <strong>Endorsed At:</strong> {{ item.screening_endorsement.endorsed_at }}
                     </p>
                     <p><strong>Status:</strong> {{ item.screening_endorsement.status }}</p>
                   </div>

                   <div v-if="getLatestStatus(item)"
                        :class="getHighlightClass(getLatestStatus(item))"
                        :style="getHighlightStyle(getLatestStatus(item))"
                   >
                     {{ getStatusValue(getLatestStatus(item)) }}
                   </div>

                   <div v-if="!getLatestStatus(item)"
                        class="highlight-orange"
                   >Verification Pending
                   </div>

                 </div>
                 <div class="col-6">
                   <div
                       v-if="!isAdmin && isRevertToApplicant(getLatestStatus(item))"
                       class="highlight-orange"
                   >To do: {{  getStatusComment(getLatestStatus(item)) }}
                   </div>
                 </div>
                 <div class="col-sm-12 mt-sm-3">
                   <el-button class="btn btn-danger el-button--default float-right"
                              @click="UpdateBtnHandler(index)">
                     Update
                   </el-button>
                   <el-button class="btn btn-danger el-button--default float-right mr-sm-2"
                              @click="RemoveBtnHandler(index)">
                     Remove
                   </el-button>
                   <div class="float-right mr-sm-2" v-if="isAdmin">
                     <drawer-component title="Comments" size="70%" btnText="Take Action">
                       <training-comments
                           :comment="item.screening_status"
                           :applicantId="candidateId"
                           :statusable_type="item.statusable_type"
                           :statusable_id="item.id"
                           :training="item"
                           :emailAddress="emailAddress"
                       />
                     </drawer-component>
                   </div>
                 </div>
               </div>
             </div>




          </div>
        </div>
      </template>
      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">Do you have any training?</label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="yesOrNoList"
                   v-model="is_training"/>
        <template v-if="is_training === 'yes'">
          <div class="form-group row align-items-center mb-sm-2 p-2">
            <label class="col-sm-2 mb-sm-0">Training Title</label>
            <app-input class="col-sm-10 mb-sm-2"
                       type="text"
                       v-model="trainingObj.title"
                       placeholder=""/>
            <label class="col-sm-2 mb-sm-0">Awarding Body</label>
            <app-input class="col-sm-10 mb-sm-2"
                       type="text"
                       v-model="trainingObj.awarding_body"
                       placeholder=""/>
            <label class="col-sm-2 mb-sm-0">Award Date</label>
            <app-input class="col-sm-10"
                       type="date"
                       :max-date="today"
                       v-model="trainingObj.award_date"
                       placeholder="Awarding Date"/>
            <label class="col-sm-2 mb-sm-0">Expiry Date</label>
            <app-input class="col-sm-10"
                       type="date"
                       :min-date="today"
                       v-model="trainingObj.expiry_date"
                       placeholder="Expiry Date"/>
          </div>
          <div class="form-group row">
            <div class="col-sm-12 mt-sm-3">
              <el-button class="btn el-button--success float-right"
                         @click="AddBtnHandler()">
                Save And Add More
              </el-button>
            </div>
          </div>
        </template>
      </div>
      <template v-if="is_modal">
        <app-modal
            :modal-id="modalId"
            modal-alignment="top"
            modal-size="fullscreen"
            @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">{{ $t("Training Detail") }}</h5>
            <button
                type="button"
                class="close outline-none"
                data-dismiss="modal"
                aria-label="Close"
            >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
            </button>
          </template>
          <template slot="body">
            <div class="card card-with-search border-0 card-with-shadow">
              <div class="form-group row align-items-center mb-sm-2 p-2">
                <label class="col-sm-2 mb-sm-0">Training Title</label>
                <app-input class="col-sm-10 mb-sm-2"
                           type="text"
                           v-model="trainingObj.title"
                           placeholder="Type training title"/>
                <label class="col-sm-2 mb-sm-0">Awarding Body</label>
                <app-input class="col-sm-10 mb-sm-2"
                           type="text"
                           v-model="trainingObj.awarding_body"
                           placeholder="Input info about awarding body"/>
                <label class="col-sm-2 mb-sm-0">Award Date</label>
                <app-input class="col-sm-10"
                           type="date"
                           v-model="trainingObj.award_date"
                           placeholder="Awarding Date"/>
                <label class="col-sm-2 mb-sm-0">Expiry Date</label>
                <app-input class="col-sm-10"
                           type="date"
                           v-model="trainingObj.expiry_date"
                           placeholder="Expiry Date"/>
              </div>
            </div>
          </template>

          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="UpdateModal"
            >
              {{ $t("Update") }}
            </button>
            <button
                type="button"
                class="btn btn-primary mr-2"
                data-dismiss="modal"
                @click="closeModal"
            >
              {{ $t("Close") }}
            </button>
          </template>
        </app-modal>
      </template>
    </form>
  </div>
</template>

<script>
import {ModalMixin} from "../../../../../../app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {_statusColors} from "@Views/Screening/utility/constant";
import {
  getHighlightClass,
  getHighlightStyle,
  getLatestStatus,
  getStatusComment,
  getStatusValue,
  isRevertToApplicant
} from "@Views/Screening/utility/common";

export default {
  name: "TrainingInfo",
  mixins: [FormMixin, ModalMixin],
  props: {
    yesOrNoList: {
      type: Array,
      required: true
    },
    training_info: {
      type: Array,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    onSaveBtn: Function,
  },
  mounted() {
    this.UpdateIsTrainingRequired();
  },
  data() {
    return {
      trainingObj: {},
      is_training: '',
      is_modal: false,
      index: 0,
      modalId: "training_modal",
      statusColors: _statusColors,
      trainingTitleList: [
        {id: "", value: "Please Select"},
        {id: "firstAid", value: "First Aid"},
        {id: "healthAndSafety", value: "Health And Safety"},
        {id: "siteTraining", value: "Site Training"},
      ],
      awardingBodyList: [
        {id: "", value: "Please Select"},
        {id: "studentGuide", value: "Student Guide"},
        {id: "pearson", value: "Pearson"},
        {id: "qa", value: "QA"},
      ],
    };
  },
  methods: {
    getHighlightStyle,
    getStatusComment,
    getLatestStatus,
    getStatusValue,
    isRevertToApplicant,
    getHighlightClass,
    RemoveBtnHandler(index) {
      if (this.training_info.length > 0) {
        this.training_info.splice(index, 1);
      }
    },
    AddBtnHandler() {
      if (Object.values(this.trainingObj).length > 0) {
        this.training_info.push(this.trainingObj);
        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
        this.trainingObj = {};
      }else{
        this.$toastr.e('Please fill all the fields.');

      }
    },
    UpdateBtnHandler(index) {
      this.trainingObj = this.training_info[index];
      this.index = index;
      this.is_modal = true;
    },
    UpdateModal() {
      this.training_info[this.index] = this.trainingObj;
      this.is_modal = false;
      this.trainingObj = {}

    },
    closeModal() {
      this.is_modal = false;
      this.trainingObj = {}
    },
    UpdateIsTrainingRequired() {
      if (this.training_info.length > 0) {
        this.is_training = 'yes';
        return;
      }
      this.is_training = 'no';
    },
  },
  computed:{
    today(){
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months start at 0
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }
  }
}
</script>
